export const getProcedureFilters = state => state.procedure.procedureFilters;

export const getProcedureGridSortCriteria = state => state.procedure.procedureGridSortCriteria;
